import { createRouter, createWebHistory, } from 'vue-router';
import i18n, { isLocale, setLocale } from '@/i18n';
import PortfolioGallery from '@/components/PortfolioGallery.vue';
import Home from '@/views/Home.vue';
import Privacy from '@/views/Privacy.vue';
const LANG_PATTERN = '(pl|de|it)?';
const routes = [
    { path: `/:lang${LANG_PATTERN}`, name: 'home', component: Home },
    { path: `/:lang${LANG_PATTERN}/portfolio`, name: 'portfolio', component: PortfolioGallery },
    {
        path: `/:lang${LANG_PATTERN}/portfolio/:category(hotels|tourism|products)`,
        name: 'portfolio-category',
        component: PortfolioGallery,
    },
    { path: `/:lang${LANG_PATTERN}/privacy`, name: 'privacy', component: Privacy },
];
const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition)
        return savedPosition;
    if (to.hash) {
        return { el: to.hash, behavior: 'smooth', top: 60 };
    }
    return { top: 0 };
};
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior,
});
router.beforeEach((to, _from, next) => {
    // Old query-string back-compat: /portfolio?category=foo → /portfolio/foo (preserving locale).
    if (to.name === 'portfolio' && typeof to.query.category === 'string') {
        const cat = to.query.category;
        if (cat === 'hotels' || cat === 'tourism' || cat === 'products') {
            const { category, ...rest } = to.query;
            next({
                name: 'portfolio-category',
                params: { ...to.params, category: cat },
                query: rest,
            });
            return;
        }
    }
    // Sync i18n with the URL locale prefix.
    const langParam = (Array.isArray(to.params.lang) ? to.params.lang[0] : to.params.lang) || '';
    const targetLocale = isLocale(langParam) ? langParam : 'en';
    if (i18n.global.locale.value !== targetLocale)
        setLocale(targetLocale);
    next();
});
export default router;
